import React, { useEffect, useState } from 'react';
import { Box, Container, useMediaQuery } from '../../../imports/muiImport';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
};

const ProductsBanner = () => {
  const categoryData = useSelector((state) => state?.MobileHomepage?.allData?.categories);

  const [selectedCategoryBanner, setSelectedCategoryBanner] = useState([]);
  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');

    if (categoryParam) {
      const userSelectedCategory = categoryParam ? categoryParam?.split('+')?.map((item) => item?.trim()) : [];
      let newSelectedCate = userSelectedCategory?.[0]?.split(" ");
      if (isMobile) {
        newSelectedCate = newSelectedCate?.[0];
      }
      const filteredCategory = categoryData?.filter((item) => newSelectedCate?.includes(item.title?.toLowerCase()));
      setSelectedCategoryBanner(filteredCategory);
    } else {
      setSelectedCategoryBanner(categoryData);
    }
  }, [location, categoryData]);


  return (
    <Container
      maxWidth="false"
      disableGutters
      sx={{ px: 1 }}
      className="slider-container"
    >
      {selectedCategoryBanner?.length === 1 ?
        (
          <Box
            key={`category-slider-${selectedCategoryBanner?.[0]?.id}`}
            component="img"
            src={selectedCategoryBanner?.[0]?.bannerImage || "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/CCm4HfudrT7b6WsUCfU5GGAyZdJfRaIJc6T5Byq2.png"}
            sx={{
              width: '100%',
              minWidth: "100%",
              height: {
                xs: 130,
                sm: 'auto',
                lg: 280
              },
              backgroundColor: "#fff",
              borderRadius: 2,
            }}
          />
        )
        :
        (
          <Slider {...settings}>
            {selectedCategoryBanner?.map((category) => (
              <Box
                key={`category-slider-${category.id}`}
                component="img"
                src={category.bannerImage || "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/CCm4HfudrT7b6WsUCfU5GGAyZdJfRaIJc6T5Byq2.png"}
                sx={{
                  width: '100%',
                  minWidth: "100%",
                  height: {
                    xs: 130,
                    sm: 190,
                    lg: 280
                  },
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              />
            ))}
          </Slider>
        )
      }
    </Container >
  );
};

export default ProductsBanner;
